export default __webpack_public_path__ + "static/media/google-tag-manager.93bb1bb5.svg";